import styled from "styled-components";

import { greyMui, rydeColors, rydeColorsGraphs } from "@ryde/theme";

export const EditorPanelStyled = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 640px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px;
  background-color: ${rydeColors.white};
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
  outline: none;

  .editor-header {
    display: flex;
    justify-content: flex-end;
    margin: -8px -8px -6px 0;
  }

  .close-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    color: ${greyMui._700};
  }

  .close-btn:hover {
    background: ${greyMui._200};
  }

  .close-btn svg {
    width: 14px;
    height: 14px;
  }

  .size-toggle {
    display: flex;
    gap: 12px;
  }

  .size-toggle > * {
    flex: 1 1 0;
  }

  .lists {
    display: flex;
    gap: 16px;
  }

  .lists-hint {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    padding: 12px;
    color: ${greyMui._500};
    font-size: 13px;
    text-align: center;
  }

  .lists > * {
    flex: 1 1 0;
    min-width: 0;
  }

  .card-filters {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .card-filters-label {
    font-size: 13px;
    font-weight: 700;
    color: ${greyMui._700};
  }

  .card-filters-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 4px;
  }
`;

export const EditorListStyled = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${greyMui._300};
  border-radius: 8px;
  overflow: hidden;

  .list-label {
    padding: 8px 12px 4px;
    font-size: 13px;
    font-weight: 700;
    color: ${greyMui._700};
  }

  .list-header {
    padding: 6px 12px 8px;
    font-weight: 600;
    color: ${rydeColorsGraphs.verticalBarDefaultColor};
    border-bottom: 1px dashed ${greyMui._300};
  }

  .list-scroll {
    max-height: 200px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .list-item {
    text-align: start;
    padding: 8px 12px;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 13px;
    color: ${greyMui._700};
  }

  .list-item:hover {
    background: ${greyMui._200};
  }

  .list-item.selected {
    color: ${rydeColorsGraphs.verticalBarDefaultColor};
    font-weight: 600;
  }
`;
